import { BodyText, Tooltip } from "@/components/ui";
import { formatPhoneNumber } from "@/lib/formatters";
import { COPY_SAFE_UNDERLINE } from "../constants";
import type { PatientDemographics } from "../types/patientDemographics";

interface AdministrativeInfoProps {
  administrative: PatientDemographics["administrative"];
}

export const AdministrativeInfo = ({
  administrative,
}: AdministrativeInfoProps) => {
  if (!administrative) return null;

  const userIdTooltipContent = administrative.chaiUserId ? (
    <div className="flex flex-col">
      <BodyText className="text-white" size="sm">
        {`Dosespot MRN: ${administrative.dosespotMrn || "N/A"}`}
      </BodyText>
      <BodyText className="text-white" size="sm">
        {`Chai User Id: ${administrative.chaiUserId}`}
      </BodyText>
    </div>
  ) : undefined;

  return (
    <>
      <BodyText tag="p" size="sm" textColor="primary">
        <Tooltip
          side="bottom"
          tooltipContentText={administrative.email || "N/A"}
        >
          <span className={COPY_SAFE_UNDERLINE}>
            {" "}
            {formatPhoneNumber(administrative.phone)}
          </span>
        </Tooltip>
      </BodyText>

      <BodyText tag="p" size="sm" textColor="primary">
        <Tooltip
          side="bottom"
          tooltipContentComponent={userIdTooltipContent}
          tooltipContentText={`Dosespot MRN: ${administrative.dosespotMrn || "N/A"}`}
        >
          <span
            className={COPY_SAFE_UNDERLINE}
          >{`User ID: ${administrative.mrn || ""}`}</span>
        </Tooltip>
      </BodyText>

      <BodyText size="sm" textColor="primary">
        {administrative.addressState}
        {administrative.temporaryResidenceState &&
          administrative.temporaryResidenceState !==
            administrative.addressState &&
          ` (${administrative.temporaryResidenceState})`}
      </BodyText>
    </>
  );
};
